<span *ngIf="hideCheckbox === false">
     <input 
          type="checkbox" 
          [checked]="checked" 
          (click)="onChange()" 
          [disabled]="disabled" 
          [style.cursor]="disabled ? 'not-allowed' : 'pointer'" 
          [attr.aria-label]="labelText"
     />
</span>
<span *ngIf="showAltIcon === true">
    <i [class]="altIconClass" 
     [attr.aria-label]="altIconLabel" 
     [ngbPopover]="altIconLabel"
     triggers="mouseenter:mouseleave"
     placement="top"
     container="body"></i>
</span>